module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/The-Story-of-God.c6b633c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/The-Story-of-God.jpg
// module id = /p4M
// module chunks = 0